import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PatchDocument } from '../models/patch.model';
import { Rate } from '../models/rate.model';

@Injectable({
  providedIn: 'root',
})
export class RateService {
  updatableProperties: string[] = ['rating'];

  constructor(private http: HttpClient) {}

  path = '/api/Rate';

  rateAUser(body: Rate): Observable<Rate> {
    const url = `${environment.API}${this.path}`;
    return this.http.post<Rate>(url, body);
  }

  getRatings(queryParams?: Map<string, any>): Observable<number> {
    const queryParametersString = this.buildQueryParameters(queryParams);
    return this.http.get<number>(
      `${environment.API}${this.path}/Ratings${queryParametersString}`,
    );
  }

  getARating(id: string): Observable<Rate> {
    const url = `${environment.API}${this.path}/${id}`;
    return this.http.get<Rate>(url);
  }

  updateRating(body: Rate): Observable<Rate> {
    const url = `${environment.API}${this.path}/${body.id}`;
    const patchDoc = this.toPatchDoc(body);

    return this.http.patch<Rate>(url, patchDoc, {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    });
  }

  protected toPatchDoc(object: Rate): PatchDocument[] {
    let doc: PatchDocument[] = [];

    if (this.updatableProperties) {
      for (const [key, value] of Object.entries(object)) {
        if (this.updatableProperties.includes(key)) {
          doc.push({
            op: 'replace',
            path: `/${key}`,
            value: value,
          });
        }
      }
    }

    return doc;
  }

  protected buildQueryParameters(queryParameters?: Map<string, any>): string {
    if (queryParameters == null || queryParameters.size == 0) {
      return '';
    }

    let queryString = '?';

    for (let entry of queryParameters.entries()) {
      if (typeof entry[1] == 'object') {
        for (let val of Array.from(entry[1])) {
          queryString += entry[0] + '=' + val + '&';
        }

        queryString = queryString.substring(0, queryString.length - 1);
      } else {
        queryString += entry[0] + '=' + queryParameters.get(entry[0]);
      }
    }

    return queryString;
  }
}
